import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntityTimelinePanel from 'components/organisms/Panels/EntityTimelinePanel/EntityTimelinePanel';

const StyledEntityTimelineSectionPanelContent = styled(EntityTimelinePanel)`
  ${ComponentStyles}
`;

StyledEntityTimelineSectionPanelContent.propTypes = {
  theme: PropTypes.object
};

export default StyledEntityTimelineSectionPanelContent;
